import React, { useState, FormEvent, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Stack, Paper, Container, TextField, CircularProgress, Typography, Button } from '@mui/material'
import ProgressButton from '../../Utils/ProgressButton'
import { entityTextField, entitySelectField } from '../../Utils/EntityField'
import { AppState } from '../../../reducers/index'
import { upsertComplaint } from '../../../actions/complaint/complaintUpsert'
import { ComplaintDetailState } from '../../../reducers/complaint/complaintDetail'
import { ComplaintInput } from '../../../models/Complaint'
import { literalStrings } from '../../../utils/StringUtils';
import { useTranslation } from 'react-i18next'
import { ISTableTitle } from '../../Utils/ISTable'
import { personTypeToDescription, visiblePersonTypes } from '../Profile'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { fetchComplaint } from '../../../actions/complaint/complaintDetail'
import { BackButton } from '../../Utils/BackButton'
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab'
import AdapterMoment from '@mui/lab/AdapterMoment'
import moment, { Moment } from 'moment'
import { useThemeContext } from '../../../theme/ThemeContext'
import { SessionState, isAdmin, isStaff, isClient, isManager, isHeadSales } from '../../../reducers/auth/session'
import { COMPLAINT_INVOICE_TYPE, COMPLAINT_ORDER_TYPE, COMPLAINT_OTHERSRECEIPT_TYPE, COMPLAINT_REMITTANCE_TYPE, receiptComplaintTypeToDescription, receiptComplaintTypes } from '../../GeneralDesc'
import { complaintCloseReasonToDescription, complaintCloseReasons } from '.'
import { GeneralDescState } from '../../../reducers/generalDescList'
import { ComplaintTypesState } from '../../../reducers/complaint/complaintTypes'
import Selector from '../../Selector'
import { fetchClient } from '../../../actions/client/clientDetail'
import { ClientDetailState } from '../../../reducers/client/clientDetail'
import { ISTextField } from '../../Utils/ISTextField'
import { FilterClientName, FilterInvoices, FilterOrders, FilterRemittances } from '../../Utils/Filters'
import { PersonDetailState } from '../../../reducers/person/personDetail'
//import { fetchPerson } from '../../../actions/person/personDetail'
import { Add, AttachFile } from '@mui/icons-material'
import { uploadComplaintMessageFile } from '../../../actions/complaint/complaintMessageUploadFile'
import { InvoiceListState } from '../../../reducers/invoice/invoiceList'
import { RemittanceListState } from '../../../reducers/remittance/remittanceList'
import ComplaintMessage from '../../../models/ComplaintMessage'
import { upsertComplaintMessage } from '../../../actions/complaint/complaintMessageUpsert'
//import Person from '../../../models/Person'

interface Props {
  session: SessionState
  complaint: ComplaintDetailState
  complaintTypes: ComplaintTypesState
  generalDesc: GeneralDescState
  clientDetail: ClientDetailState
  person: PersonDetailState
  invoice: InvoiceListState
  remittance: RemittanceListState
  edit?: boolean
}

const empty: ComplaintInput = {
  dateOpen: null,
  dateClose: null,
  //  category: '',
  //type: '',
  message: '',
  status: 'U',
  receiptType_1: null,
  receiptId_1: '',
  receiptType_2: null,
  receiptId_2: '',
  receiptType_3: null,
  receiptId_3: '',
  personType: '',
  complaintTypeId: 0,
  toPersonTypeId: 0
}

const ComplaintUpsert: React.FC<Props> = ({ complaint, session, generalDesc, complaintTypes, clientDetail, person, edit }) => {
  const [changed, setChanged] = useState<boolean>(false)
  const [complaintInfo, setComplaintInfo] = useState<ComplaintInput>(complaint.complaint || empty)
  const [category, setCategory] = useState(complaint.complaint?.category || '')
  const [complaintType, setComplaintType] = useState(complaint.complaint?.type || '')
  const [attached, setAttached] = useState<number>(0)
  const [showUploadFile, setShowUploadFile] = useState<boolean>(false)
  //const [personAssignedTo, setPersonAssignedTo] = useState<string>('')
  //const [personInternalAssignedTo, setPersonInternalAssignedTo] = useState<string>('')

  const [fetchingUploadFile, setFetchingUploadFile] = useState<boolean>(false)
  const [complaintId, setComplaintId] = useState<number | undefined>(undefined)
  const [complaintFileId, setComplaintFileId] = useState<{} | undefined>(undefined)
  const [message, setMessage] = useState<ComplaintMessage | undefined>(undefined)
  const [finish, setFinish] = useState<boolean>(false)

  const fileInputs = [React.useRef<HTMLInputElement>(null), React.useRef<HTMLInputElement>(null), React.useRef<HTMLInputElement>(null)]

  const dispatch = useDispatch()
  const params = useParams<{ complaintId: string }>()
  const history = useHistory()
  const location = useLocation()
  const { t } = useTranslation('complaint')
  const { theme } = useThemeContext()
  const [receipt, addReceipt] = useState<number>(1)

  useEffect(() => {
    if (params.complaintId)
      dispatch(fetchComplaint(params.complaintId))
  }, [dispatch, params.complaintId])


  useEffect(() => {
    if (complaintInfo.personType === 'C')
      dispatch(fetchClient(complaintInfo.toPersonTypeId.toString()))
  }, [dispatch, complaintInfo.personType, complaintInfo.toPersonTypeId])

  /*
    useEffect(() => {
      if (complaintInfo.assignedToId)
        {
        dispatch(fetchPerson(complaintInfo.assignedToId.toString(), (person: Person) => 
        setPersonAssignedTo(person.fullName)))
        }
  
    }, [dispatch, complaintInfo.assignedToId])
  
    useEffect(() => {
      if (complaintInfo.internalAssignedToId)
       {    
        dispatch(fetchPerson(complaintInfo.internalAssignedToId.toString(), (person: Person) => 
        setPersonInternalAssignedTo(person.fullName)))
        }
    }, [dispatch, complaintInfo.internalAssignedToId])
  */

  const change = (newComplaintInfo: ComplaintInput) => {
    setComplaintInfo(newComplaintInfo)
    setChanged(true)
  }

  const handleComplaintId = (complaintId: number) => {
    setComplaintId(complaintId)
    if (message)
      dispatch(upsertComplaintMessage({ ...message, complaintId: complaintId }))
  }

  const changeComplaint = async (event: FormEvent) => {
    event.preventDefault()
    if (!isAdmin(session) && !isStaff(session) && !isManager(session) && !isHeadSales(session)) {
      complaintInfo.personType = isClient(session) ? 'C' : ''
      complaintInfo.toPersonTypeId = session.byPersonTypeId ? session.byPersonTypeId : 0
    }
    if (!complaintInfo.dateOpen )
      complaintInfo.dateOpen = moment().tz("America/Argentina/Buenos_Aires").format()

    try {
      setFetchingUploadFile(true)
      await dispatch(upsertComplaint(complaintInfo, handleComplaintId))
    }
    catch {
    }
  }


  const updateToPersonTypeId = (value: number) => {
    if (value !== complaintInfo.toPersonTypeId) {
      setComplaintInfo({ ...complaintInfo, toPersonTypeId: value })
      setChanged(true)
    }
  }


  /*
  const updateAssignedToId = (value: number) => {
    if (value !== complaintInfo.assignedToId) {
      setComplaintInfo({ ...complaintInfo, assignedToId: value, dateAssignedTo: moment().tz("America/Argentina/Buenos_Aires").format() })
      dispatch(fetchPerson(value.toString(), (person: Person) => 
      setPersonAssignedTo(person.fullName)))
      setChanged(true)
    }
  }

  const updateInternalAssignedToId = (value: number) => {
    if (value !== complaintInfo.internalAssignedToId) {
      setComplaintInfo({ ...complaintInfo, internalAssignedToId: value, internalDateAssignedTo: moment().tz("America/Argentina/Buenos_Aires").format() })
      dispatch(fetchPerson(value.toString(), (person: Person) => 
      setPersonInternalAssignedTo(person.fullName)))
      setChanged(true)
    }
  }
*/

  const updateReceiptId = (index: number, value: any) => {
    /*
    ver de pensar en una lupa para la busqueda del comprobante, que traiga un dialogo para buscar y devuelva el valor ????
    
    porque no re-renderiza cuando se actualiza el valor en el campo del Filtro
    
    o poner un campo de solo lectura al lado del buscador par que quede alli el comprobante encontrado.                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    */
    switch (index) {
      case 1: {
        if (value !== complaintInfo.receiptId_1) {
          setComplaintInfo({ ...complaintInfo, receiptId_1: value })
          setChanged(true)
        }
        return
      }
      case 2: {
        if (value !== complaintInfo.receiptId_2) {
          setComplaintInfo({ ...complaintInfo, receiptId_2: value })
          setChanged(true)
        }
        return
      }
      case 3: {
        if (value !== complaintInfo.receiptId_3) {
          setComplaintInfo({ ...complaintInfo, receiptId_3: value })
          setChanged(true)
        }
        return
      }
    }
  }

  const updateDateOpen = (newDate: Moment | null) => {
    if (newDate) {
      const dateOpen = newDate.tz("America/Argentina/Buenos_Aires").format()
      setComplaintInfo({ ...complaintInfo, dateOpen })
      setChanged(true)
    }
  }

  const updateDateClose = (newDate: Moment | null) => {
    if (newDate) {
      const dateClose = newDate.tz("America/Argentina/Buenos_Aires").format()
      setComplaintInfo({ ...complaintInfo, dateClose })
    }
    else setComplaintInfo({ ...complaintInfo, dateClose: null })
    setChanged(true)
  }

  const updateInternalDateClose = (newDate: Moment | null) => {
    if (newDate) {
      const internalDateClose = newDate.tz("America/Argentina/Buenos_Aires").format()
      setComplaintInfo({ ...complaintInfo, internalDateClose })
    }
    else setComplaintInfo({ ...complaintInfo, internalDateClose: null })
    setChanged(true)
  }

  const updateType = (e: any) => {
    const description = e.target.value
    const complaintTypeId = setDataComplaintType(description)
    let newCategory: string | undefined = category

    if (description) {
      const complaintCategory = complaintTypes.complaintTypes?.find((type) => type.description === description)?.categoryId || 0
      newCategory = generalDesc.generalDesc?.find((desc) => desc.id === complaintCategory)?.description
    }

    if (complaintTypeId) {
      if (isClient(session))
        setComplaintInfo({ ...complaintInfo, complaintTypeId: complaintTypeId })
      else {
        setComplaintInfo({
          ...complaintInfo, complaintTypeId: complaintTypeId,
          status: 'U',
          assignedToId: null, dateAssignedTo: null,
          internalAssignedToId: null, internalDateAssignedTo: null
        })
        setMessage({
          message: `Reasignación de soporte. Tipo: ${description} - Categoría: ${newCategory}`, complaintId: complaintId!, status: 'U', ownerName: '', date: moment().tz("America/Argentina/Buenos_Aires").format()
        })
      }

      setChanged(true)
    }
  }

  const setDataComplaintType = (description: any): number | null => {
    if (description) {
      const complaintCategory = complaintTypes.complaintTypes?.find((type) => type.description === description)?.categoryId || 0
      const newCategory = generalDesc.generalDesc?.find((desc) => desc.id === complaintCategory)?.description
      if (newCategory)
        setCategory(newCategory)
      setComplaintType(description)
      return complaintTypes.complaintTypes?.find((type) => type.description === description)?.id || 0
    }
    return null
  }

  const complaintTypeList = () => {
    const list = complaintTypes.complaintTypes?.filter((type) => (type.active))
    return list ? [...list.map(it => it.description), ''] : []
  }


  /*****************/

  const setAttachedFileInfo = async (fileNumber: number) => {
    const files = (fileInputs[fileNumber - 1] as any).current.files as File[];
    if (files.length && files[0]) {
      setChanged(true)
      setAttached(attached + 1)
    }
  }

  const handleAttachedFile = async (id: number) => {
    /// ver fileInput 0 a 2 ir fileid_1 2 3
    const fileCount = fileInputs.filter((fileInput, index) => {
      const files = (fileInput as any).current.files as File[];
      return (files.length !== 0)
    }).length
    if (fileCount === 0) {
      setFinish(true)
      return
    }
    var ids = {}
    fileInputs.forEach(async (fileInput, index) => {
      const files = (fileInput as any).current.files as File[];
      if (!files.length) {
      }
      else {
        if (files[0]) {
          const formData = new FormData();
          formData.append("file", files[0]);
          formData.append("fileName", files[0].name);
          dispatch(uploadComplaintMessageFile(formData, id, async (fileId: string) => {
            if (index === 0)
              ids = { fileId_1: fileId }
            if (index === 1)
              ids = { ...ids, fileId_2: fileId }
            if (index === 2)
              ids = { ...ids, fileId_3: fileId }
            if (index === fileCount - 1) {
              setComplaintInfo({ ...complaintInfo, ...ids })
              setComplaintFileId(ids);
            }
          })
          )
        }
      }
    })
  }

  useEffect(() => {
    if (complaintId) handleAttachedFile(complaintId)
    // eslint-disable-next-line react-hooks/exhaustive-deps      
  }, [complaintId])

  useEffect(() => {
    if (complaintFileId) {
      dispatch(upsertComplaint({ ...complaintInfo, ...complaintFileId, id: complaintId },
        () => setFinish(true)))

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps          
  }, [complaintFileId, complaintId, dispatch])


  const handleFinish = () => {
    if (location.state)
      (location.state as any).update = !(location.state as any).update
    history.goBack()
  }


  useEffect(() => {
    if (finish) {
      setFetchingUploadFile(false)
      setChanged(false)
      handleFinish()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps          
  }, [finish, dispatch])


  /*****************/

  useEffect(() => {
    if (complaint.complaint) {
      setComplaintInfo(params.complaintId ? complaint.complaint : empty)
      if (params.complaintId && complaint.complaint.status === 'U' && !changed) {
        dispatch(upsertComplaint({ ...complaint.complaint, status: 'R' },
          () => setComplaintInfo(complaint.complaint ? { ...complaint.complaint, status: 'R' } : empty)))
      }
      setCategory(params.complaintId ? complaint.complaint?.category : '')
      setComplaintType(params.complaintId ? complaint.complaint?.type : '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps        
  }, [complaint.complaint, params.complaintId])

  const ComplaintInfoField = useMemo(() => entityTextField(change),
    // eslint-disable-next-line react-hooks/exhaustive-deps      
    [])

  const ComplaintInfoSelectField = useMemo(() => entitySelectField(change),
    // eslint-disable-next-line react-hooks/exhaustive-deps      
    [])

  const translatePersonTypeDescription = (value: string): string => t(personTypeToDescription(value))
  const translateReceiptTypeDescription = (value: string): string => t(receiptComplaintTypeToDescription(value))
  const translateCloseReasonDescription = (value: string): string => t(complaintCloseReasonToDescription(value))
  //const translateComplaintStatusTypeDescription = (value: string): string => t(complaintStatusTypeToDescription(value))

  return (
    <Container>
      <Paper style={{ borderRadius: "10px", margin: "10px" }}>
        <ISTableTitle title={params.complaintId ? `${t('complaint')} ${params.complaintId}` : t('title')} />
        <Paper style={{ padding: "10px" }}>
          <form onSubmit={changeComplaint}>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <Selector
                key="type"
                label={t("type")}
                menuItems={complaintTypeList()} // generalDescList()}
                onChange={updateType}
                value={complaintType}
                style={{ marginRight: "10px", width: '100%' }}
                required
                disabled={(complaintInfo.dateClose ? true : edit !== undefined ? edit : false)}
              />
              <ISTextField
                key="category"
                variant="outlined"
                label={t("category")}
                value={category}
                fullWidth={false}
                size="medium"
                disabled
              />
            </Stack>
            {[
              literalStrings(t("description"), "message"),
            ].map(([label, attr], i) =>
              <ComplaintInfoField
                key={i}
                variant="outlined"
                label={label}
                entity={complaintInfo}
                attr={attr}
                size="medium"
                maxRows={5}
                minRows={5}
                inputProps={{ maxLength: 512 }}
                multiline
                disabled={!isClient(session)}
                required={isClient(session)}
              />)
            }
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ComplaintInfoSelectField
                key="receiptType"
                label={t("receipt")}
                entity={complaintInfo}
                attr="receiptType_1"
                menuItems={receiptComplaintTypes}
                textAdapter={translateReceiptTypeDescription}
                style={{ width: "270px", maxWidth: "270px", marginRight: "10px" }}
                disabled={!isClient(session)}
                required={isClient(session)}
              />
              {(!isClient(session)) && complaintInfo.receiptId_1 &&
                <ComplaintInfoField
                  key="receiptId"
                  variant="outlined"
                  label={t("receiptId")}
                  entity={complaintInfo}
                  attr={"receiptId_1"}
                  size="medium"
                  disabled={true} />}
              {((isClient(session)) && complaintInfo.receiptType_1 === COMPLAINT_OTHERSRECEIPT_TYPE) &&
                <ComplaintInfoField
                  key="receiptId"
                  variant="outlined"
                  label={t("receiptId")}
                  entity={complaintInfo}
                  attr={"receiptId_1"}
                  size="medium"
                  required={((isClient(session)) && complaintInfo.receiptType_1 === COMPLAINT_OTHERSRECEIPT_TYPE)}
                />}
              {(isClient(session)) && complaintInfo.receiptType_1 === COMPLAINT_INVOICE_TYPE &&
                <FilterInvoices
                  style={{ width: "900px", marginTop: "16px" }}
                  name="id_factura"
                  label={t("receiptId")}
                  isOptionEqualToValue={(option, value) => option.id_factura === value.id_factura}
                  onChange={(_data: any, value: any) => { updateReceiptId(1, value) }}
                  controlledLength={3}
                  required={(isClient(session)) && complaintInfo.receiptType_1 === COMPLAINT_INVOICE_TYPE}
                />}
              {(isClient(session)) && complaintInfo.receiptType_1 === COMPLAINT_ORDER_TYPE &&
                <FilterOrders
                  style={{ width: "900px", marginTop: "16px" }}
                  name="id_pedido"
                  label={t("receiptId")}
                  isOptionEqualToValue={(option, value) => option.id_pedido === value.id_pedido}
                  onChange={(_data: any, value: any) => { updateReceiptId(1, value) }}
                  required={(isClient(session)) && complaintInfo.receiptType_1 === COMPLAINT_ORDER_TYPE}
                  controlledLength={3}
                />}
              {(isClient(session)) && complaintInfo.receiptType_1 === COMPLAINT_REMITTANCE_TYPE &&
                <FilterRemittances
                  style={{ width: "900px", marginTop: "16px" }}
                  name="id_remito"
                  label={t("receiptId")}
                  isOptionEqualToValue={(option, value) => option.id_remito === value.id_remito}
                  onChange={(_data: any, value: any) => { updateReceiptId(1, value) }}
                  required={(isClient(session)) && complaintInfo.receiptType_1 === COMPLAINT_REMITTANCE_TYPE}
                  controlledLength={3}
                />}
            </Stack>
            <Stack display={receipt >= 2 || (!isClient(session) && complaintInfo.receiptId_2) ? "flex" : "none"} flexDirection="row" flexGrow={1} >
              <ComplaintInfoSelectField
                key="receiptType"
                label={t("receipt")}
                entity={complaintInfo}
                attr="receiptType_2"
                menuItems={receiptComplaintTypes}
                textAdapter={translateReceiptTypeDescription}
                style={{ width: "270px", maxWidth: "270px", marginRight: "10px" }}
                disabled={!isClient(session)}
              />
              {(!isClient(session)) && complaintInfo.receiptId_2 &&
                <ComplaintInfoField
                  key="receiptId"
                  variant="outlined"
                  label={t("receiptId")}
                  entity={complaintInfo}
                  attr={"receiptId_2"}
                  size="medium"
                  disabled={true} />}
              {((isClient(session)) && complaintInfo.receiptType_2 === COMPLAINT_OTHERSRECEIPT_TYPE) &&
                <ComplaintInfoField
                  key="receiptId"
                  variant="outlined"
                  label={t("receiptId")}
                  entity={complaintInfo}
                  attr={"receiptId_2"}
                  size="medium"
                />}
              {(isClient(session)) && complaintInfo.receiptType_2 === COMPLAINT_INVOICE_TYPE &&
                <FilterInvoices
                  style={{ width: "900px", marginTop: "16px" }}
                  name="id_factura"
                  label={t("receiptId")}
                  isOptionEqualToValue={(option, value) => option.id_factura === value.id_factura}
                  onChange={(_data: any, value: any) => { updateReceiptId(2, value) }}
                />}
              {(isClient(session)) && complaintInfo.receiptType_2 === COMPLAINT_ORDER_TYPE &&
                <FilterOrders
                  style={{ width: "900px", marginTop: "16px" }}
                  name="id_pedido"
                  label={t("receiptId")}
                  isOptionEqualToValue={(option, value) => option.id_pedido === value.id_pedido}
                  onChange={(_data: any, value: any) => { updateReceiptId(2, value) }}
                />}
              {(isClient(session)) && complaintInfo.receiptType_2 === COMPLAINT_REMITTANCE_TYPE &&
                <FilterRemittances
                  style={{ width: "900px", marginTop: "16px" }}
                  name="id_remito"
                  label={t("receiptId")}
                  isOptionEqualToValue={(option, value) => option.id_remito === value.id_remito}
                  onChange={(_data: any, value: any) => { updateReceiptId(2, value) }}
                />}
            </Stack>
            <Stack display={receipt === 3 || (!isClient(session) && complaintInfo.receiptId_3) ? "flex" : "none"} flexDirection="row" flexGrow={1} >
              <ComplaintInfoSelectField
                key="receiptType"
                label={t("receipt")}
                entity={complaintInfo}
                attr="receiptType_3"
                menuItems={receiptComplaintTypes}
                textAdapter={translateReceiptTypeDescription}
                style={{ width: "270px", maxWidth: "270px", marginRight: "10px" }}
                disabled={!isClient(session)}
              />
              {(!isClient(session)) && complaintInfo.receiptId_3 &&
                <ComplaintInfoField
                  key="receiptId"
                  variant="outlined"
                  label={t("receiptId")}
                  entity={complaintInfo}
                  attr={"receiptId_3"}
                  size="medium"
                  disabled={true} />}

              {((isClient(session)) && complaintInfo.receiptType_3 === COMPLAINT_OTHERSRECEIPT_TYPE) &&
                <ComplaintInfoField
                  key="receiptId"
                  variant="outlined"
                  label={t("receiptId")}
                  entity={complaintInfo}
                  attr={"receiptId_3"}
                  size="medium"
                />}
              {(isClient(session)) && complaintInfo.receiptType_3 === COMPLAINT_INVOICE_TYPE &&
                <FilterInvoices
                  style={{ width: "900px", marginTop: "16px" }}
                  name="id_factura"
                  label={t("receiptId")}
                  isOptionEqualToValue={(option, value) => option.id_factura === value.id_factura}
                  onChange={(_data: any, value: any) => { updateReceiptId(3, value) }}
                />}
              {(isClient(session)) && complaintInfo.receiptType_3 === COMPLAINT_ORDER_TYPE && <FilterOrders
                style={{ width: "900px", marginTop: "16px" }}
                name="id_pedido"
                label={t("receiptId")}
                isOptionEqualToValue={(option, value) => option.id_pedido === value.id_pedido}
                onChange={(_data: any, value: any) => { updateReceiptId(3, value) }}
              />}
              {(isClient(session)) && complaintInfo.receiptType_3 === COMPLAINT_REMITTANCE_TYPE &&
                <FilterRemittances
                  style={{ width: "900px", marginTop: "16px" }}
                  name="id_remito"
                  label={t("receiptId")}
                  isOptionEqualToValue={(option, value) => option.id_remito === value.id_remito}
                  onChange={(_data: any, value: any) => { updateReceiptId(3, value) }}
                />}
            </Stack>
            <Stack display={receipt === 3 || !isClient(session) ? "none" : "flex"} flexDirection='row' justifyContent="flex-end" sx={{ padding: "5px" }}>
              <Button aria-label="addReceipt" style={{ textTransform: 'none', padding: "8px" }} disabled={receipt === 3 || !isClient(session)} size="small" onClick={(event: FormEvent) => { event.preventDefault(); event.stopPropagation(); addReceipt(receipt + 1) }}>
                <Add sx={{ color: theme.palette.success.dark }} />
                <Typography color={theme.palette.success.dark}>{t('addReceipt')}</Typography>
              </Button>
            </Stack>
            <Stack display={!isClient(session) ? 'none' : "flex"} flexDirection='column' alignItems='flex-end' justifyContent="flex-end" sx={{ padding: "5px", marginBottom: "5px" }}>
              <Button disabled={attached === 3 || !isClient(session)} size="small" style={{ textTransform: 'none', padding: "8px" }} onClick={(event: FormEvent) => { event.preventDefault(); event.stopPropagation(); setShowUploadFile(attached !== 3) }}>
                <AttachFile sx={{ color: theme.palette.success.dark }} />
                <Typography color={theme.palette.success.dark}>{t('attachFile')}</Typography>
              </Button>

              <TextField
                //InputLabelProps={{ shrink: true }}
                inputProps={{ accept: "application/pdf" }}
                inputRef={fileInputs[0]}
                //label={t('attachFile')}
                margin="normal"
                size='small'
                variant="outlined"
                onChange={() => setAttachedFileInfo(1)}
                type="file"
                sx={{ marginTop: '8px', display: showUploadFile && attached >= 0 ? 'inherit' : 'none' }}
                //fullWidth
                disabled={/*attached ||*/ !isClient(session)}
              />
              <TextField
                //InputLabelProps={{ shrink: true }}
                inputProps={{ accept: "application/pdf" }}
                inputRef={fileInputs[1]}
                //label={t('attachFile')}
                margin="normal"
                size='small'
                variant="outlined"
                onChange={() => setAttachedFileInfo(2)}
                type="file"
                sx={{ marginTop: '8px', display: showUploadFile && attached >= 1 ? 'inherit' : 'none' }}
                //fullWidth
                disabled={/*attached ||*/ !isClient(session)}
              />
              <TextField
                //InputLabelProps={{ shrink: true }}
                inputProps={{ accept: "application/pdf" }}
                inputRef={fileInputs[2]}
                //label={t('attachFile')}
                margin="normal"
                size='small'
                variant="outlined"
                onChange={() => setAttachedFileInfo(3)}
                type="file"
                sx={{ marginTop: '8px', display: showUploadFile && attached >= 2 ? 'inherit' : 'none' }}
                //fullWidth
                disabled={/*attached ||*/ !isClient(session)}
              />
            </Stack>
            {((isAdmin(session)) || isManager(session)) &&
              <Stack display="flex" flexDirection="row" flexGrow={1} >
                <ComplaintInfoSelectField
                  key="personType"
                  label={t("personType")}
                  entity={complaintInfo}
                  attr="personType"
                  menuItems={visiblePersonTypes}
                  textAdapter={translatePersonTypeDescription}
                  style={{ width: "270px", marginRight: "10px" }}
                  required
                />
                {complaintInfo.personType === 'C' && <FilterClientName
                  style={{ marginRight: "10px", marginTop: "16px" }}
                  name="codigo_cliente"
                  label={t('title', { ns: 'client' })}
                  onChange={(_data: any, value: number) => updateToPersonTypeId(value)} />}
                <ComplaintInfoField
                  key="toPersonTypeId"
                  name='topersontypeid'
                  variant="outlined"
                  label={t("toPersonTypeId")}
                  entity={complaintInfo}
                  attr="toPersonTypeId"
                  size="medium"
                  required={complaintInfo.personType in ['C', 'P']}
                  style={{ maxWidth: "100px" }}
                  disabled
                />
                <ISTextField
                  key="nombrefantasia"
                  variant="outlined"
                  label={t("personType")}
                  value={complaintInfo.personType === 'C' && clientDetail.client ? clientDetail.client.nombrefantasia : ''}
                  style={{ marginLeft: "10px" }}
                  size="medium"
                  disabled
                />
              </Stack>}
            {/*(isAdmin(session) || isHeadSales(session) || isStaff(session)) &&
              <Stack display="flex" flexDirection="row" flexGrow={1} >
                <FilterPersonName
                  style={{ marginRight: "10px", marginTop: "16px" }}
                  name="id"
                  label={t('title', { ns: 'person' })}
                  onChange={(_data: any, value: number) => updateAssignedToId(value)} />
                <ISTextField
                  key="fullName"
                  variant="outlined"
                  label={t("assignedToName")}
                  value={complaintInfo.assignedToId && personAssignedTo ? personAssignedTo : ''}
                  style={{ marginLeft: "10px" }}
                  size="medium"
                  disabled
                />
            </Stack>*/}
            {/*(isAdmin(session) || isHeadSales(session) || isStaff(session)) &&
              <Stack display="flex" flexDirection="row" flexGrow={1} >
                <FilterPersonName
                  style={{ marginRight: "10px", marginTop: "16px" }}
                  name="id"
                  label={t('title', { ns: 'person' })}
                  onChange={(_data: any, value: number) => updateInternalAssignedToId(value)} />
                <ISTextField
                  key="fullName"
                  variant="outlined"
                  label={t("internalAssignedToName")}
                  value={complaintInfo.internalAssignedToId && personInternalAssignedTo ? personInternalAssignedTo : ''}
                  style={{ marginLeft: "10px" }}
                  size="medium"
                  disabled
                />
          </Stack>*/}
            {(isAdmin(session) || isStaff(session) || isManager(session) || isHeadSales(session)) &&
              <Stack display="flex" flexDirection="row" flexGrow={1} >
                {complaintInfo.internalDateClose &&
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                      label={t("internalDateClose")}
                      inputFormat="DD/MM/yyyy"
                      renderInput={(params) => <TextField sx={{
                        maxWidth: 200, marginTop: "15px",
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: theme.palette.action.disabled
                        },
                        "& .MuiFormLabel-root.Mui-disabled": {
                          color: theme.palette.action.disabled,
                        },
                        svg: { fill: theme.typography.button.color }
                      }} {...params} />}
                      value={complaintInfo.internalDateClose ? moment(new Date(complaintInfo.internalDateClose)) : null}
                      onChange={updateInternalDateClose}
                      disabled
                    />
                  </LocalizationProvider>}
                {complaintInfo.internalCloseReason &&
                  <ComplaintInfoSelectField
                    key="internalCloseReason"
                    label={t("internalCloseReason")}
                    menuItems={complaintCloseReasons} // generalDescList()}
                    textAdapter={translateCloseReasonDescription}
                    attr="internalCloseReason"
                    entity={complaintInfo}
                    style={{ marginLeft: "10px", width: '350px' }}
                    disabled
                  />}
              </Stack>}
            {(isAdmin(session) || isStaff(session) || isManager(session) || isHeadSales(session)) && <Stack display="flex" flexDirection="row" flexGrow={1} >
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  label={t("dateOpen")}
                  inputFormat="DD/MM/yyyy"
                  renderInput={(params) => <TextField sx={{
                    maxWidth: 200, marginTop: "15px", marginRight: "10px",
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: theme.palette.action.disabled
                    },
                    "& .MuiFormLabel-root.Mui-disabled": {
                      color: theme.palette.action.disabled,
                    },
                    svg: { fill: theme.typography.button.color }
                  }} {...params} />}
                  value={complaintInfo.dateOpen ? moment(new Date(complaintInfo.dateOpen)) : null}
                  onChange={updateDateOpen}
                  disabled={!isClient(session)}
                />
              </LocalizationProvider>
              {/*<ComplaintInfoSelectField
                key="status"
                label={t("status")}
                entity={complaintInfo}
                attr="status"
                menuItems={complaintStatusTypes}
                textAdapter={translateComplaintStatusTypeDescription}
                style={{ width: "120px", marginRight: "10px" }}
                disabled={isClient(session) || (complaintInfo.dateClose ? true : false)}
                />*/}
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  label={t("dateClose")}
                  inputFormat="DD/MM/yyyy"
                  renderInput={(params) => <TextField sx={{
                    maxWidth: 200, marginTop: "15px",
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: theme.palette.action.disabled
                    },
                    "& .MuiFormLabel-root.Mui-disabled": {
                      color: theme.palette.action.disabled,
                    },
                    svg: { fill: theme.typography.button.color }
                  }} {...params} />}
                  value={complaintInfo.dateClose ? moment(new Date(complaintInfo.dateClose)) : null}
                  onChange={updateDateClose}
                  disabled
                />
              </LocalizationProvider>
              <ComplaintInfoSelectField
                key="closeReason"
                label={t("closeReason")}
                menuItems={complaintCloseReasons} // generalDescList()}
                textAdapter={translateCloseReasonDescription}
                attr="closeReason"
                entity={complaintInfo}
                style={{ marginLeft: "10px", width: '350px' }}
                disabled={isClient(session) || (complaintInfo.dateClose ? true : edit !== undefined ? !edit : false)}
              />
            </Stack>}
            {(isAdmin(session) || isStaff(session) || isManager(session) || isHeadSales(session) || complaintInfo.dateClose) && <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ComplaintInfoField
                key="closeResolution"
                variant="outlined"
                label={t("closeResolution")}
                entity={complaintInfo}
                attr="closeResolution"
                size="medium"
                maxRows={3}
                minRows={3}
                multiline
                inputProps={{ maxLength: 255 }}
                disabled={isClient(session) || (complaintInfo.dateClose ? true : edit !== undefined ? !edit : false)}
              />
            </Stack>}
            <Stack display="flex" flexDirection='row' justifyContent="space-between" sx={{ padding: "5px" }}>
              <BackButton />
              <Stack display="flex" flexDirection='row' justifyContent="space-between">
                <ProgressButton state={complaint} disabled={!changed}>
                  {t('save')}
                </ProgressButton>
                {fetchingUploadFile &&
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: "4px" }}>
                    <CircularProgress size={25} />
                  </div>
                }
              </Stack>
            </Stack>
          </form>
        </Paper>
      </Paper>
    </Container>

  )
}

const mapStateToProps = (state: AppState) => ({
  session: state.session,
  complaint: state.complaintDetail,
  complaintTypes: state.complaintTypes,
  generalDesc: state.generalDescList,
  clientDetail: state.clientDetail,
  person: state.personDetail,
  invoice: state.invoiceList,
  remittance: state.remittanceList
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(ComplaintUpsert)
